<template>
  <o-form-group :label="label" :error-field="errorField" :class="{'has-error': errorField in $root.errors}">
    <o-input-percentage-control v-model="localValue" :type="type" :readonly="readonly" :placeholder="placeholder"
                                :apply-range="applyRange" :min="min" :max="max" :step="step" :lazy="lazy">
    </o-input-percentage-control>
  </o-form-group>
</template>

<script>
  export default {
    name: 'o-input-percentage',
    props: {
      value: {
        default: null
      },
      label: {
        type: String
      },
      type: {
        type: String,
        default: 'number'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      errorField: {
        type: String
      },
      placeholder: {
        type: String
      },
      applyRange: {
        type: Boolean,
        default: true
      },
      step: {
        type: Number,
        default: 0.01
      },
      onlyInteger: {
        type: Boolean,
        default: true
      },
      min: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: 99
      },
      lazy: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      localValue: ''
    }),

    mounted() {
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },

    methods: {}
  }
</script>
